/**
 * Real-world football free-kick constants.
 * FIFA goal: 7.32 m wide × 2.44 m tall.
 * Pro free kicks taken from ~18–25 m. We use 18 m for the puzzle.
 *
 * Power → speed mapping per brief Section 3.1:
 *   0%   → 8 m/s   (soft chip)
 *   100% → 32 m/s  (full whip)
 */

// Physics
export const G = 9.81;
export const AIR_DENSITY = 1.225;
export const BALL_MASS = 0.43;
export const BALL_RADIUS = 0.11;
export const BALL_AREA = Math.PI * BALL_RADIUS * BALL_RADIUS;
export const DRAG_COEFFICIENT = 0.275;
export const K_DRAG = (0.5 * AIR_DENSITY * DRAG_COEFFICIENT * BALL_AREA) / BALL_MASS;
export const K_MAGNUS = 0.018;
export const K_WIND = 0.4;

// Kick mapping — brief Section 3.1
export const SPEED_MIN = 8;        // m/s (soft chip)
export const SPEED_MAX = 32;       // m/s (full whip)
export const AIM_ANGLE_RANGE_RAD = (25 * Math.PI) / 180;
export const LAUNCH_ELEVATION_RAD = (12 * Math.PI) / 180;
export const SPIN_MAX = 12;

// Simulation
export const SIM_DT = 1 / 240;
export const SIM_MAX_TIME = 5;

// Scoring (only on GOAL)
export const SCORE_BASE = 400;
export const SCORE_CORNER_BONUS = 600;

// Trajectory sampling
export const TRAJECTORY_SAMPLE_EVERY = 4;       // 60 samples/sec
export const SHARE_TRAJECTORY_SAMPLES = 50;     // brief: 50 @ 100ms intervals
export const SHARE_TRAJECTORY_INTERVAL_SEC = 0.1;

// Post / crossbar tolerance — brief Section 3.3 (±5 cm)
export const FRAME_TOLERANCE_M = 0.05;

// Goal-corner thresholds for `top_bin` / `near_post` detail
export const TOP_HEIGHT_FRAC = 0.75;            // top 25% of goal height
export const NEAR_POST_FRAC = 0.7;              // ≥70% of half-width = near post
